export const logout = () => {
  localStorage.removeItem("admin_token");

  // optional: clear other data
  localStorage.clear();

  window.location.href = "/login";
};